import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { JockeyAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails';
import { Selection } from 'src/domains/sportsbook/webview/components/Selection';
import { withConfig } from 'src/withConfig';

export const SilkCellRaceBox = styled(LazyImageSilk, { label: 'SilkCellRaceBox' })`
    flex: 0 0 36px;
    height: 100%;
    width: 36px;
`;

interface SelectionWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setSelectionWrapper = (variant: DefaultComponentVariantType | null): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin: 4px;
            width: 64px;
            height: 40px;
        `;
    }
    return css``;
};

export const SelectionWrapper = styled(Selection, { label: 'SelectionWrapper' })<SelectionWrapperPropsType>`
    align-self: stretch;
    ${({ variant }): SerializedStyles => setSelectionWrapper(variant)}
`;

export const RunnerCell = styled('div', { label: 'RunnerCell' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 8px;
    justify-content: start;
    padding: 8px 12px;
    overflow: hidden;
`;

export const RunnerCellDetails = withConfig(theme => styled('div', { label: 'RunnerCellDetails' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
`);

export const JockeyAndTrainerDetailsBox = withConfig(theme => styled(JockeyAndTrainerDetails, { label: 'JockeyAndTrainerDetailsBox' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    width: 100%;
`);
